import { BuscarCautelasDisponiveisDto, CautelaDto } from "@/dtos/BuscarCautelasDisponiveisDto";
import CautelaService from "@/services/CautelaService";
import { useEffect, useState } from "react";
import {
    Carousel,
    CarouselApi,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "@/components/ui/carousel"
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Filter, ShoppingCart } from "lucide-react";
import { useCarrinho } from "@/contexts/CarrinhoProvider";
import { useAuth } from "@/contexts/AuthProvider";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { Skeleton } from "@/components/ui/skeleton";
import { ModalEscolherDezenas } from "./ModalEscolherDezenas";
import { useLocation } from 'react-router-dom';
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Separator } from "@/components/ui/separator";
import { CompraRapida } from "@/components/CompraRapida";
import StorageUtils from "@/utils/StorageUtils";
import CompraRapidaOqueE from "@/components/CompraRapidaOqueE";
import {
    labelPlural,
    labelPluralCaps,
    labelPluralLower,
    labelSingular,
    labelSingularLower,
} from "@/utils/copyTituloBilhete";

export function ComprarTitulosPage() {
    const [loading, setLoading] = useState(true);
    const [cautelaDisponivel, setCautelaDisponivel] = useState<BuscarCautelasDisponiveisDto>();
    const [cautelas, setCautelas] = useState<CautelaDto[]>([]);
    const [api, setApi] = useState<CarouselApi>()
    const { addItemCarrinho, addItemSurpresinha, carrinhoCautelas, qtdCarrinho } = useCarrinho()
    const [qtdSurpresinha, setQtdSurpresinha] = useState(0)
    const [adicionandoSurpresinha, setAdicionandoSurpresinha] = useState(false);
    const [qtdDisponivelSurpresinha, setQtdDisponivelSurpresinha] = useState<number[]>([])
    const [carrinhoCautelasLogado, setCarrinhoCautelasLogado] = useState<number[]>([]);
    const { isAuthorized } = useAuth();
    const [exibirModalSelecionarDezenas, setExibirModalSelecionarDezenas] = useState(false)
    const navigate = useNavigate();
    const { toast } = useToast()
    const [somenteLeitura, setSomenteLeitura] = useState(false);
    const location = useLocation();
    const compraRapida = import.meta.env.VITE_APP_COMPRARAPIDA === 'true';
    const [searchParams] = useSearchParams();

    useEffect(() => {
        async function initialLoad() {
            setLoading(true)
            buscarQtdSurpresinha()
            await buscarTitulos()

            if (location.pathname.toLowerCase().indexOf('/titulosdisponiveis') >= 0) {
                setSomenteLeitura(true)
            }

            setLoading(false)
        }

        initialLoad()
    }, [])

    useEffect(() => {
        let idVendedor = searchParams.get('idVendedor');
        if (idVendedor) {
            StorageUtils.setIdVendedor(idVendedor);
        }
    }, [])

    useEffect(() => {
        api?.scrollTo(0);
    }, [cautelas])

    async function buscarQtdSurpresinha() {
        try {
            const { Data: result } = await CautelaService.buscarQtdSurpresinha();
            setQtdDisponivelSurpresinha(result);
        } catch (error: any) {

        }
    }

    async function buscarTitulos() {
        try {
            let result: BuscarCautelasDisponiveisDto = {} as BuscarCautelasDisponiveisDto;

            if (isAuthorized) {
                const { Data } = await CautelaService.buscarCautelasAlocadas();
                result = Data;
            } else {
                const { Data } = await CautelaService.buscarCautelasDisponiveis();
                result = Data;
            }

            setCautelaDisponivel(result)
            setCautelas(result.Cautelas)
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            })
        }
    }

    async function buscarNovascautelas() {
        try {
            let result: BuscarCautelasDisponiveisDto = {} as BuscarCautelasDisponiveisDto;

            if (isAuthorized) {
                const { Data } = await CautelaService.buscarNovasCautelasAlocadas();
                result = Data;
            } else {
                const { Data } = await CautelaService.buscarCautelasDisponiveis();
                result = Data;
            }

            setCautelaDisponivel(result)
            setCautelas(result.Cautelas)
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            })
        }
    }

    function formatarDezenas(dezenas: string) {
        const dezenasFormatas: number[] = [];

        if (dezenas == null || dezenas == undefined) {
            return [];
        }

        for (let index = 0; index < dezenas.length; index += 2) {
            const dezena = dezenas.slice(index, index + 2);
            dezenasFormatas.push(Number(dezena))
        }

        return dezenasFormatas.map(dezena => `${dezena}`.padStart(2, '0'))
    }

    function formatarDescricaoPremio(descricao: string) {
        const texto = descricao.replace(/^prêmio extra\s*/i, '');

        const regexSorteiosEValor = /((?:SORTEIO DIA\s*\d{2}\/\d{2}-\d{2}h\s*)+)-\s*(R\$.*)/i;
        const match = texto.match(regexSorteiosEValor);

        if (!match) {
            return texto;
        }

        const regexSorteioDia = /SORTEIO DIA\s*\d{2}\/\d{2}-\d{2}h/ig;
        const sorteios = match[1].match(regexSorteioDia) ?? [];
        const valor = match[2];

        return (
            <>
                {sorteios.map((sorteio, idx) => (
                    <div key={idx}>{sorteio.trim()}</div>
                ))}
                <div>{valor.trim()}</div>
            </>
        );
    }

    async function handleSelecionarCautela(idCautela: number) {
        try {
            setCarrinhoCautelasLogado(c => [...c, idCautela])
            await addItemCarrinho(idCautela);
        } catch (error: any) {
            setCarrinhoCautelasLogado(old => old.filter(c => c !== idCautela))
            return;
        }

        setTimeout(() => {
            if (cautelas.length === 1) {
                buscarTitulos()
            } else {
                setCautelas(old => old.filter(c => c.IdCautela !== idCautela))
            }
        }, 500);
    }

    async function handleAdicionarSurpresinha() {
        setAdicionandoSurpresinha(true);
        try {
            const qtdSurpresinhaAdd = qtdSurpresinha;
            await addItemSurpresinha(qtdSurpresinhaAdd);
        } catch (error) {
            return;
        }

        setQtdSurpresinha(0)
        setAdicionandoSurpresinha(false)
    }

    async function toggleModalSelecionarDezenas() {
        setExibirModalSelecionarDezenas(!exibirModalSelecionarDezenas)
    }

    async function buscarTitulosPorDezenas(dezenas: string[]) {
        let result: BuscarCautelasDisponiveisDto = {} as BuscarCautelasDisponiveisDto;

        if (isAuthorized) {
            const { Data } = await CautelaService.buscarCautelasAlocadasPorDezenas(dezenas);
            result = Data;
        } else {
            const { Data } = await CautelaService.buscarCautelasDisponiveisPorDezenas(dezenas);
            result = Data;
        }

        if (result.Cautelas.length === 0) {
            toast({
                variant: 'destructive',
                description: `Nenhum ${labelSingularLower()} foi encontrado com as Dezenas Selecionadas`,
                duration: 4000
            })
            return;
        } else {
            toast({
                variant: 'success',
                description: `Veja os ${labelPluralLower()} que foram encontrados`,
                duration: 4000
            })
        }

        setCautelaDisponivel(result)
        setCautelas(result.Cautelas)
        toggleModalSelecionarDezenas();
    }

    return (
        <>
            {
                loading && (
                    <>
                        <div className="flex w-full justify-center mt-4">
                            Carregando informações do Sorteio...
                        </div>
                        <div className="flex w-full justify-center mt-5 mb-10 gap-4">
                            <Skeleton className="h-80 w-3/4 hidden md:flex lg:w-full" />
                            <Skeleton className="h-80 w-3/4 hidden md:flex lg:w-full" />
                            <Skeleton className="h-80 w-3/4 lg:w-full" />
                        </div>
                    </>
                )
            }

            {
                !loading && (
                    <div>
                        {
                            cautelaDisponivel && (
                                <div className="text-center">
                                    <h1 className="text-primary font-semibold text-xl mt-2 mb-1">Sorteio {cautelaDisponivel.DataSorteio} &nbsp;-&nbsp; {cautelas[0].Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</h1>

                                    {
                                        !somenteLeitura && (
                                            <Card className="relative border-2 w-3/4 lg:w-full min-h-40 mx-auto">

                                                <div className="absolute top-2 right-2">
                                                    <CompraRapidaOqueE />
                                                </div>

                                                <CardContent className="p-3 flex justify-center items-center h-full min-h-40">
                                                    <CompraRapida />
                                                </CardContent>

                                            </Card>
                                        )
                                    }

                                    <ModalEscolherDezenas
                                        buscarTitulos={buscarTitulosPorDezenas}
                                        exibirModal={exibirModalSelecionarDezenas}
                                        toggleModal={toggleModalSelecionarDezenas} />

                                    <p className="flex gap-3 justify-center">
                                        {
                                            somenteLeitura && <span>Escolha seus {labelPluralLower()}</span>
                                        }
                                        {
                                            !somenteLeitura && <span>Escolha seus {labelPluralLower()}</span>
                                        }

                                        <span>
                                            <Filter className="cursor-pointer text-primary" onClick={toggleModalSelecionarDezenas} />
                                        </span>
                                    </p>


                                    <Carousel setApi={setApi} className="w-3/4 lg:w-full mb-5 mx-auto">
                                        <CarouselContent>
                                            {
                                                cautelas.map((cautela) => (
                                                    <CarouselItem className="lg:basis-1/3" key={cautela.IdCautela}>
                                                        <Card className={(carrinhoCautelas.find(id => id === cautela.IdCautela) !== undefined || carrinhoCautelasLogado.find(id => id === cautela.IdCautela) !== undefined) ? 'border-2 border-green-600 ' : 'border-2'}>
                                                            <CardContent className="p-3">

                                                                <div>
                                                                    {
                                                                        somenteLeitura ? (
                                                                            (
                                                                                <>
                                                                                    <AlertDialog>
                                                                                        <AlertDialogTrigger className="mb-4">
                                                                                            <Button
                                                                                                type="button"
                                                                                                variant="foreground">
                                                                                                Selecionar
                                                                                            </Button>
                                                                                        </AlertDialogTrigger>
                                                                                        <AlertDialogContent>
                                                                                            <AlertDialogHeader>
                                                                                                <AlertDialogTitle className="text-2xl text-primary">
                                                                                                    {cautela.Titulos[0].NumeroSorte}
                                                                                                </AlertDialogTitle>
                                                                                                <AlertDialogDescription>
                                                                                                    Informe o numero da sorte acima para seu vendedor
                                                                                                </AlertDialogDescription>
                                                                                            </AlertDialogHeader>
                                                                                            <AlertDialogFooter>
                                                                                                <AlertDialogAction>OK</AlertDialogAction>
                                                                                            </AlertDialogFooter>
                                                                                        </AlertDialogContent>
                                                                                    </AlertDialog>
                                                                                </>
                                                                            )
                                                                        ) : (
                                                                            <Button
                                                                                disabled={carrinhoCautelas.find(id => id === cautela.IdCautela) !== undefined || carrinhoCautelasLogado.find(id => id === cautela.IdCautela) !== undefined}
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    if (carrinhoCautelas.find(id => id === cautela.IdCautela)) {
                                                                                        return;
                                                                                    }

                                                                                    handleSelecionarCautela(cautela.IdCautela)
                                                                                }}
                                                                                variant="foreground"
                                                                                className="mb-2">
                                                                                {(carrinhoCautelas.find(id => id === cautela.IdCautela) !== undefined || carrinhoCautelasLogado.find(id => id === cautela.IdCautela) !== undefined) ? 'Adicionando ao carrinho...' : 'Adicionar ao Carrinho                                            '}
                                                                            </Button>
                                                                        )
                                                                    }
                                                                </div>

                                                                <p className="text-primary font-semibold">{labelSingular()} nº: {cautela.Titulos[0].Numero}</p>

                                                                <div className="text-primary font-semibold">Numero da Sorte:&nbsp;
                                                                    <span>{cautela.Titulos.map((titulo) => titulo.NumeroSorte).join(" e ")}</span>
                                                                </div>

                                                                <div className="flex flex-col items-center mt-2 gap-2">
                                                                    {
                                                                        cautela.Titulos.map((titulo, i) => (
                                                                            <div key={titulo.IdTitulo} className="my-2">
                                                                                <div className="flex flex-wrap justify-center w-72 select-none">
                                                                                    {
                                                                                        formatarDezenas(titulo.Dezenas).map((dezena, index) => {
                                                                                            return (
                                                                                                <span key={`${titulo.Dezenas}-${index}`} className="text-center tabular-nums rounded-full m-1 h-12 w-12 p-3 border-2 shadow-md">
                                                                                                    {dezena}
                                                                                                </span>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>

                                                                                {
                                                                                    cautela.Titulos.length > 0 && cautela.Titulos.length !== (i + 1) && (
                                                                                        <Separator className="mt-5" />
                                                                                    )
                                                                                }
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </div>


                                                            </CardContent>

                                                        </Card>
                                                    </CarouselItem>
                                                ))
                                            }
                                            <CarouselItem className="md:basis-1/3 lg:basis-1/3">
                                                <Card>
                                                    <CardContent className="p-4 min-h-80 flex justify-center items-center">
                                                        <Button onClick={() => {
                                                            buscarNovascautelas()
                                                        }}>CARREGAR MAIS {labelPluralCaps()}</Button>
                                                    </CardContent>
                                                </Card>
                                            </CarouselItem>
                                        </CarouselContent>
                                        <CarouselPrevious />
                                        <CarouselNext />
                                    </Carousel>

                                    {
                                        qtdCarrinho > 0 && !somenteLeitura &&
                                        (
                                            <Button onClick={() => {
                                                if (isAuthorized) {
                                                    navigate('/compra/finalizar')
                                                } else {
                                                    navigate('/Acessar?redirect=compra/finalizar')
                                                }
                                            }} className="w-full md:w-[80%] mt-4 hidden md:flex mx-auto justify-center">
                                                Finalizar Compra ({qtdCarrinho} {labelPlural()})
                                            </Button>
                                        )
                                    }

                                    {
                                        !somenteLeitura && (<>


                                            {
                                                compraRapida && (
                                                    <>
                                                        <p className="my-6">
                                                            Ou a quantidade de {labelPluralLower()} <span className="text-primary font-semibold">Surpresinha</span>
                                                        </p>
                                                        <Card className='border-2 w-[80%] flex mx-auto justify-center'>
                                                            <CardContent className="p-3">

                                                                <div className="flex flex-col md:flex-row justify-center gap-3">
                                                                    {
                                                                        qtdDisponivelSurpresinha.map((qtd, index) => (
                                                                            <Button
                                                                                key={'qtd-disponivel-supresinha-' + index}
                                                                                variant={qtdSurpresinha === qtd ? 'default' : 'foreground'}
                                                                                onClick={() => {
                                                                                    setQtdSurpresinha(qtd)
                                                                                }} size="lg">
                                                                                {qtd} {labelPlural()}
                                                                            </Button>
                                                                        ))
                                                                    }
                                                                </div>

                                                                <div className="flex items-center justify-center gap-3 mb-5 mt-2">
                                                                    <Button
                                                                        disabled={qtdSurpresinha === 0}
                                                                        onClick={() => {
                                                                            if (qtdSurpresinha === 0) {
                                                                                return;
                                                                            }
                                                                            setQtdSurpresinha(old => old - 1)
                                                                        }}
                                                                        size="sm"
                                                                        variant='outline'>
                                                                        -
                                                                    </Button>
                                                                    <Button
                                                                        size="sm"
                                                                        variant='outline'>
                                                                        {qtdSurpresinha}
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() => {
                                                                            setQtdSurpresinha(old => old + 1)
                                                                        }}
                                                                        size="sm"
                                                                        variant='outline'>
                                                                        +
                                                                    </Button>
                                                                </div>
                                                                <div>
                                                                    <Button
                                                                        disabled={qtdSurpresinha === 0 || adicionandoSurpresinha}
                                                                        type="button"
                                                                        onClick={handleAdicionarSurpresinha}
                                                                        variant="foreground"
                                                                        className="mt-2">
                                                                        {adicionandoSurpresinha ? 'Adicionando ao Carrinho...' : 'Adicionar ao Carrinho'}
                                                                    </Button>
                                                                </div>
                                                            </CardContent>

                                                        </Card>
                                                    </>
                                                )
                                            }

                                            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 m-4 text-center">
                                                {
                                                    cautelaDisponivel.Premios.map((premio, index) => (
                                                        <Card className="flex justify-center items-center w-[80%] md:w-48 min-h-40" key={'numero-sorte-' + index + '-' + premio.Descricao}>
                                                            <CardContent className="flex flex-col font-semibold mt-5">
                                                                <h1 className="text-2xl leading-none tracking-tight text-center text-primary">
                                                                    {!premio.PremioExtra ? `${premio.OrdemSorteio}° PRÊMIO` : 'PRÊMIO EXTRA'}
                                                                </h1>
                                                                <span className="text-center">
                                                                    {formatarDescricaoPremio(premio.Descricao)}
                                                                </span>
                                                 
                                                            </CardContent>
                                                        </Card>
                                                    ))
                                                }
                                            </div>
                                        </>)
                                    }
                                </div>
                            )
                        }

                        {
                            qtdCarrinho > 0 && !somenteLeitura && (
                                <div className="bg-buttondefault pt-2 h-10 w-full fixed bottom-0 rounded-t-2xl md:hidden">
                                    <div className="flex justify-center">
                                        <div onClick={() => {
                                            if (isAuthorized) {
                                                navigate('/compra/finalizar')
                                            } else {
                                                navigate('/Acessar?redirect=compra/finalizar')
                                            }
                                        }} className='flex flex-row font-bold items-center cursor-pointer text-buttondefault-foreground  hover:text-buttondefault-foreground/70'>
                                            <span className="mx-10 flex gap-3">
                                                <ShoppingCart /> Finalizar Compra ({qtdCarrinho} {labelPlural()})
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                )
            }
        </>
    )
}